import React, { useEffect, useState } from 'react';
import { Host } from '@wix/sdk';

import type { AutomaticPanelProps } from './AutomaticPanel';
import { loadPanelService } from './panelsService';

export const useAutomaticPanel = (props: AutomaticPanelProps) => {
  const [PanelContent, setPanelContent] =
    useState<React.ComponentType<any> | null>(null);

  useEffect(() => {
    const createPanelContent = async (host: Host) => {
      try {
        const panelService = await loadPanelService(host);
        const { panel } = await panelService.getPanel({
          panelType: props.panelType ?? 'manifest',
        });
        setPanelContent(() => panel.Component);
      } catch (error) {
        console.error(error);
        setPanelContent(null);
      }
    };

    const initializeHost = async (): Promise<Host> => {
      if ('getHost' in props && props.getHost) {
        /**
         * TODO: getHost should accept props, at least editorPointer
         */
        return props.getHost();
      }
      if ('host' in props && props.host) {
        return props.host;
      }
      throw new Error('Either host or getHost must be provided');
    };

    initializeHost()
      .then(createPanelContent)
      .catch((error) =>
        console.error('Failed to initialize host or load panel:', error),
      );
  }, [props]);

  return PanelContent ? <PanelContent /> : <>Loading…</>;
};
